import { BaseBus } from "./BaseBus";
import { DateFunctions } from '../static/date-functions';

 export class DispatchAssetBus extends BaseBus
 { 
     constructor(busObj: DispatchAssetBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
     }
 dispatchId: any;
 assetId: any;
 companyId: any;
 assetNumber: string;
 name: string;
 description: string;
 serial: string;
 model: string;
 manufacturerId: any;
 assetImg: any[];
 inventoryLocationId: any;
 insertDt: Date;
 insertUserId: any;
 updateDt: Date;
 updateUserId: any;
 dispatchNumber: string;
 inventoryLocationName: string;
 manufacturerName: string;
 cost: number;
 statusName: string;
 assetStatusId: any;
 rFIDTag: string;
 cO: number; 
}
